function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [],
    _n = !0,
    _d = !1,
    _e = void 0;
  try {
    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0);
  } catch (err) {
    _d = !0, _e = err;
  } finally {
    try {
      _n || null == _i["return"] || _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}
import MapState from "./map-state";
import { LinearInterpolator } from "./transition";
import { TRANSITION_EVENTS } from "./transition-manager";
var NO_TRANSITION_PROPS = {
    transitionDuration: 0
  },
  LINEAR_TRANSITION_PROPS = {
    transitionDuration: 300,
    transitionEasing: function transitionEasing(t) {
      return t;
    },
    transitionInterpolator: new LinearInterpolator(),
    transitionInterruption: TRANSITION_EVENTS.BREAK
  },
  PITCH_MOUSE_THRESHOLD = 5,
  PITCH_ACCEL = 1.2,
  ZOOM_ACCEL = .01,
  EVENT_TYPES = {
    WHEEL: ["wheel"],
    PAN: ["panstart", "panmove", "panend"],
    PINCH: ["pinchstart", "pinchmove", "pinchend"],
    DOUBLE_TAP: ["doubletap"],
    KEYBOARD: ["keydown"]
  },
  MapControls = function () {
    function MapControls() {
      _classCallCheck(this, MapControls), this._state = {
        isDragging: !1
      }, this.events = [], this.handleEvent = this.handleEvent.bind(this);
    }
    var _Mathabs = Math.abs;
    return _createClass(MapControls, [{
      key: "handleEvent",
      value: function handleEvent(event) {
        switch (this.mapState = this.getMapState(), event.type) {
          case "panstart":
            return this._onPanStart(event);
          case "panmove":
            return this._onPan(event);
          case "panend":
            return this._onPanEnd(event);
          case "pinchstart":
            return this._onPinchStart(event);
          case "pinchmove":
            return this._onPinch(event);
          case "pinchend":
            return this._onPinchEnd(event);
          case "doubletap":
            return this._onDoubleTap(event);
          case "wheel":
            return this._onWheel(event);
          case "keydown":
            return this._onKeyDown(event);
          default:
            return !1;
        }
      }
    }, {
      key: "getCenter",
      value: function getCenter(event) {
        var _event$offsetCenter = event.offsetCenter,
          x = _event$offsetCenter.x,
          y = _event$offsetCenter.y;
        return [x, y];
      }
    }, {
      key: "isFunctionKeyPressed",
      value: function isFunctionKeyPressed(event) {
        var srcEvent = event.srcEvent;
        return !!(srcEvent.metaKey || srcEvent.altKey || srcEvent.ctrlKey || srcEvent.shiftKey);
      }
    }, {
      key: "setState",
      value: function setState(newState) {
        Object.assign(this._state, newState), this.onStateChange && this.onStateChange(this._state);
      }
    }, {
      key: "updateViewport",
      value: function updateViewport(newMapState) {
        var extraProps = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          extraState = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
          oldViewport = this.mapState ? this.mapState.getViewportProps() : {},
          newViewport = Object.assign({}, newMapState.getViewportProps(), extraProps),
          viewStateChanged = Object.keys(newViewport).some(function (key) {
            return oldViewport[key] !== newViewport[key];
          });
        viewStateChanged && this.onViewStateChange && this.onViewStateChange({
          viewState: newViewport
        }), viewStateChanged && this.onViewportChange && this.onViewportChange(newViewport), this.setState(Object.assign({}, newMapState.getInteractiveState(), extraState));
      }
    }, {
      key: "getMapState",
      value: function getMapState(overrides) {
        return new MapState(Object.assign({}, this.mapStateProps, this._state, overrides));
      }
    }, {
      key: "setOptions",
      value: function setOptions(options) {
        var onChangeViewport = options.onChangeViewport,
          _options$touchZoomRot = options.touchZoomRotate,
          touchZoomRotate = void 0 === _options$touchZoomRot || _options$touchZoomRot,
          onViewStateChange = options.onViewStateChange,
          onViewportChange = options.onViewportChange,
          _options$onStateChang = options.onStateChange,
          onStateChange = void 0 === _options$onStateChang ? this.onStateChange : _options$onStateChang,
          _options$eventManager = options.eventManager,
          eventManager = void 0 === _options$eventManager ? this.eventManager : _options$eventManager,
          _options$scrollZoom = options.scrollZoom,
          scrollZoom = void 0 === _options$scrollZoom || _options$scrollZoom,
          _options$dragPan = options.dragPan,
          dragPan = void 0 === _options$dragPan || _options$dragPan,
          _options$dragRotate = options.dragRotate,
          dragRotate = void 0 === _options$dragRotate || _options$dragRotate,
          _options$doubleClickZ = options.doubleClickZoom,
          doubleClickZoom = void 0 === _options$doubleClickZ || _options$doubleClickZ,
          _options$touchZoom = options.touchZoom,
          _options$touchRotate = options.touchRotate,
          _options$keyboard = options.keyboard,
          keyboard = void 0 === _options$keyboard || _options$keyboard;
        this.onViewStateChange = onViewStateChange, this.onViewportChange = onViewportChange || onChangeViewport, this.onStateChange = onStateChange, this.mapStateProps && this.mapStateProps.height !== options.height && this.updateViewport(new MapState(options)), this.mapStateProps = options, this.eventManager !== eventManager && (this.eventManager = eventManager, this._events = {}, this.toggleEvents(this.events, !0));
        var isInteractive = !!(this.onViewStateChange || this.onViewportChange);
        this.toggleEvents(EVENT_TYPES.WHEEL, isInteractive && scrollZoom), this.toggleEvents(EVENT_TYPES.PAN, isInteractive && (dragPan || dragRotate)), this.toggleEvents(EVENT_TYPES.PINCH, isInteractive && touchZoomRotate), this.toggleEvents(EVENT_TYPES.DOUBLE_TAP, isInteractive && doubleClickZoom), this.toggleEvents(EVENT_TYPES.KEYBOARD, isInteractive && keyboard), this.scrollZoom = scrollZoom, this.dragPan = dragPan, this.dragRotate = dragRotate, this.doubleClickZoom = doubleClickZoom, this.touchZoom = touchZoomRotate && (void 0 === _options$touchZoom || _options$touchZoom), this.touchRotate = touchZoomRotate && void 0 !== _options$touchRotate && _options$touchRotate, this.keyboard = keyboard;
      }
    }, {
      key: "toggleEvents",
      value: function toggleEvents(eventNames, enabled) {
        var _this = this;
        this.eventManager && eventNames.forEach(function (eventName) {
          _this._events[eventName] !== enabled && (_this._events[eventName] = enabled, enabled ? _this.eventManager.on(eventName, _this.handleEvent) : _this.eventManager.off(eventName, _this.handleEvent));
        });
      }
    }, {
      key: "_onPanStart",
      value: function _onPanStart(event) {
        var pos = this.getCenter(event),
          newMapState = this.mapState.panStart({
            pos: pos
          }).rotateStart({
            pos: pos
          });
        return this.updateViewport(newMapState, NO_TRANSITION_PROPS, {
          isDragging: !0
        });
      }
    }, {
      key: "_onPan",
      value: function _onPan(event) {
        return this.isFunctionKeyPressed(event) || event.rightButton ? this._onPanRotate(event) : this._onPanMove(event);
      }
    }, {
      key: "_onPanEnd",
      value: function _onPanEnd() {
        var newMapState = this.mapState.panEnd().rotateEnd();
        return this.updateViewport(newMapState, null, {
          isDragging: !1
        });
      }
    }, {
      key: "_onPanMove",
      value: function _onPanMove(event) {
        if (!this.dragPan) return !1;
        var pos = this.getCenter(event),
          newMapState = this.mapState.pan({
            pos: pos
          });
        return this.updateViewport(newMapState, NO_TRANSITION_PROPS, {
          isDragging: !0
        });
      }
    }, {
      key: "_onPanRotate",
      value: function _onPanRotate(event) {
        if (!this.dragRotate) return !1;
        var deltaX = event.deltaX,
          deltaY = event.deltaY,
          _this$getCenter = this.getCenter(event),
          _this$getCenter2 = _slicedToArray(_this$getCenter, 2),
          centerY = _this$getCenter2[1],
          startY = centerY - deltaY,
          _this$mapState$getVie = this.mapState.getViewportProps(),
          width = _this$mapState$getVie.width,
          height = _this$mapState$getVie.height,
          deltaScaleY = 0;
        0 < deltaY ? _Mathabs(height - startY) > PITCH_MOUSE_THRESHOLD && (deltaScaleY = deltaY / (startY - height) * PITCH_ACCEL) : 0 > deltaY && startY > PITCH_MOUSE_THRESHOLD && (deltaScaleY = 1 - centerY / startY), deltaScaleY = Math.min(1, Math.max(-1, deltaScaleY));
        var newMapState = this.mapState.rotate({
          deltaScaleX: deltaX / width,
          deltaScaleY: deltaScaleY
        });
        return this.updateViewport(newMapState, NO_TRANSITION_PROPS, {
          isDragging: !0
        });
      }
    }, {
      key: "_onWheel",
      value: function _onWheel(event) {
        if (!this.scrollZoom) return !1;
        event.srcEvent.preventDefault();
        var pos = this.getCenter(event),
          delta = event.delta,
          scale = 2 / (1 + Math.exp(-_Mathabs(delta * ZOOM_ACCEL)));
        0 > delta && 0 !== scale && (scale = 1 / scale);
        var newMapState = this.mapState.zoom({
          pos: pos,
          scale: scale
        });
        return this.updateViewport(newMapState, NO_TRANSITION_PROPS);
      }
    }, {
      key: "_onPinchStart",
      value: function _onPinchStart(event) {
        var pos = this.getCenter(event),
          newMapState = this.mapState.zoomStart({
            pos: pos
          }).rotateStart({
            pos: pos
          });
        return this._state.startPinchRotation = event.rotation, this.updateViewport(newMapState, NO_TRANSITION_PROPS, {
          isDragging: !0
        });
      }
    }, {
      key: "_onPinch",
      value: function _onPinch(event) {
        if (!this.touchZoom && !this.touchRotate) return !1;
        var newMapState = this.mapState;
        if (this.touchZoom) {
          var scale = event.scale,
            pos = this.getCenter(event);
          newMapState = newMapState.zoom({
            pos: pos,
            scale: scale
          });
        }
        if (this.touchRotate) {
          var rotation = event.rotation,
            startPinchRotation = this._state.startPinchRotation;
          newMapState = newMapState.rotate({
            deltaScaleX: -(rotation - startPinchRotation) / 180
          });
        }
        return this.updateViewport(newMapState, NO_TRANSITION_PROPS, {
          isDragging: !0
        });
      }
    }, {
      key: "_onPinchEnd",
      value: function _onPinchEnd() {
        var newMapState = this.mapState.zoomEnd().rotateEnd();
        return this._state.startPinchRotation = 0, this.updateViewport(newMapState, null, {
          isDragging: !1
        });
      }
    }, {
      key: "_onDoubleTap",
      value: function _onDoubleTap(event) {
        if (!this.doubleClickZoom) return !1;
        var pos = this.getCenter(event),
          isZoomOut = this.isFunctionKeyPressed(event),
          newMapState = this.mapState.zoom({
            pos: pos,
            scale: isZoomOut ? .5 : 2
          });
        return this.updateViewport(newMapState, Object.assign({}, LINEAR_TRANSITION_PROPS, {
          transitionInterpolator: new LinearInterpolator({
            around: pos
          })
        }));
      }
    }, {
      key: "_onKeyDown",
      value: function _onKeyDown(event) {
        if (!this.keyboard) return !1;
        var newMapState,
          funcKey = this.isFunctionKeyPressed(event),
          mapStateProps = this.mapStateProps;
        switch (event.srcEvent.keyCode) {
          case 189:
            newMapState = funcKey ? this.getMapState({
              zoom: mapStateProps.zoom - 2
            }) : this.getMapState({
              zoom: mapStateProps.zoom - 1
            });
            break;
          case 187:
            newMapState = funcKey ? this.getMapState({
              zoom: mapStateProps.zoom + 2
            }) : this.getMapState({
              zoom: mapStateProps.zoom + 1
            });
            break;
          case 37:
            newMapState = funcKey ? this.getMapState({
              bearing: mapStateProps.bearing - 15
            }) : this.mapState.pan({
              pos: [100, 0],
              startPos: [0, 0]
            });
            break;
          case 39:
            newMapState = funcKey ? this.getMapState({
              bearing: mapStateProps.bearing + 15
            }) : this.mapState.pan({
              pos: [-100, 0],
              startPos: [0, 0]
            });
            break;
          case 38:
            newMapState = funcKey ? this.getMapState({
              pitch: mapStateProps.pitch + 10
            }) : this.mapState.pan({
              pos: [0, 100],
              startPos: [0, 0]
            });
            break;
          case 40:
            newMapState = funcKey ? this.getMapState({
              pitch: mapStateProps.pitch - 10
            }) : this.mapState.pan({
              pos: [0, -100],
              startPos: [0, 0]
            });
            break;
          default:
            return !1;
        }
        return this.updateViewport(newMapState, LINEAR_TRANSITION_PROPS);
      }
    }]), MapControls;
  }();
export { MapControls as default };